import axios_ from 'axios';

const axios = axios_.create();

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.maxRedirects = 0;


axios.interceptors.response.use(e => {
    if (e.request.responseURL.split('/').pop() === 'login') {
        return Promise.reject('You are not logged in, please log on and then try again.')
    }
    return e;
})

export default axios;
